import { RiskZoneV2Key } from '@/types/riskZone';
import { secondaryColors } from '@/theme/colors';

export const adjustRiskZoneV2KeyToNumber = (riskZone: RiskZoneV2Key): number => {
  return riskZone === 'issued' ? 1 : 0;
};

export const adjustRiskZoneV2NumberToColor = (riskZone: number): string => {
  switch (riskZone) {
    case 1:
      return secondaryColors.danger.numeric;
    default:
      return secondaryColors.success.numeric;
  }
};
